// 서버에서 읽은 수량식은 저장된 qty 와 같은 값이 나올 때만 살린다 — 어긋나면 qty 가 이긴다.

import { evalQtyExpr, isExpr, QTY_EXPR_MAX_LENGTH } from "./qty-expr";

/** 평수만 없어 못 푼 식을 남길지 — 평수를 넣으면 문법상 풀리는 식만 남긴다. */
export const keepsWithoutArea = (text: string): boolean => {
  const probe = evalQtyExpr(text, { area_pyeong: 1, area_m2: 1 });
  return probe.ok || (probe.kind !== "syntax" && probe.kind !== "paren");
};

/** 저장된 `qty`·`qty_expr`·평수로 편집기에 보일 식. 식이 qty 를 만들지 못하면 null 이다. */
export const trustedQtyExpr = (
  qty: number,
  expr: string | null | undefined,
  area_pyeong: number | null,
  area_m2?: number | null
): string | null => {
  const text = (expr ?? "").trim();
  if (text.length > QTY_EXPR_MAX_LENGTH || !isExpr(text)) return null;
  const result = evalQtyExpr(text, { area_pyeong, area_m2 });
  // 평수가 없으면 어긋남을 가릴 수 없다 — 편집기가 평수를 지울 때처럼 식을 둔다(문법만 본다).
  if (!result.ok && result.kind === "no_area") return keepsWithoutArea(text) ? text : null;
  // 둘 다 `numeric(14,3)` 자리라 소수 셋째까지 같으면 같은 값이다.
  return result.ok && Math.round(result.value * 1000) === Math.round(qty * 1000)
    ? text
    : null;
};
